import React, { memo } from 'react';

import { IconSize } from 'constants/coreDesignSystem';

import { sizePropsTypes } from './icons.constants';

const RunIcon = ({ size = IconSize[24], ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4182 7.58172 20 12 20C16.4182 20 20 16.4182 20 12C20 7.58172 16.4182 4 12 4ZM11 10.3476V13.6524L13.6236 12L11 10.3476ZM9 8.89823C9 7.95383 10.0404 7.37954 10.8395 7.88285L15.7642 10.9846C16.5115 11.4553 16.5115 12.5447 15.7642 13.0154L10.8395 16.1172C10.0404 16.6205 9 16.0462 9 15.1018L9 8.89823Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

RunIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(RunIcon);
